module.exports = __webpack_public_path__ + "img/japanese-paper_white.20d2850f.jpg";